import React from 'react'
import './WorkingDayBadge.css'

interface WorkingDayBadgeProps {
  day: string
  isAvailable: boolean
  onClick?: () => void
  title?: string
}

const WorkingDayBadge: React.FC<WorkingDayBadgeProps> = ({
  day,
  isAvailable,
  onClick,
  title,
}) => {
  return (
    <span
      className={`working-day-badge ${isAvailable ? 'available' : 'not-available'}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      title={title}
    >
      {day}
    </span>
  )
}

export default WorkingDayBadge
